export function useVuetifyColors() {
  const bodyStyle = getComputedStyle(document.body)
  const primary = bodyStyle.getPropertyValue('--v-theme-primary')
  const secondary = bodyStyle.getPropertyValue('--v-theme-secondary')
  const relevizeBlack = bodyStyle.getPropertyValue('--v-theme-relevize-black')

  return {
    primary,
    secondary,
    relevizeBlack,
  }
}

export function useVuetifyColorsRgb() {
  const { primary, secondary, relevizeBlack } = useVuetifyColors()

  function wrapRgb(color) {
    return `rgb(${color})`
  }

  return {
    primaryRgb: wrapRgb(primary),
    secondaryRgb: wrapRgb(secondary),
    relevizeBlackRgb: wrapRgb(relevizeBlack),   
  }
}